import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  payment = 'PricingPaymentWindowsExtra',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/extra-slots/',
    component: () => import('@/modules/extra-slots/layout/LayoutPage.vue'),
    children: [
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/extra-slots/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
